import React, { useEffect, useState, useCallback } from 'react';
import LevelRun from './LevelRun';
import { Campaign } from '../types';
import { ProgressService } from '../services/ProgressService';

interface StudentReflectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  studentId: string;
  squadId: string;
  sessionId: string;
  levelId: string;
}

const StudentReflectionModal: React.FC<StudentReflectionModalProps> = ({
  isOpen,
  onClose,
  studentId,
  squadId,
  sessionId,
  levelId,
}) => {
  const [campaigns, setCampaigns] = useState<Campaign[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const eligible = await ProgressService.getEligibleCampaigns(studentId, squadId);
      setCampaigns(eligible);
    } catch (e) {
      console.error('Failed to load eligible campaigns for reflection modal', e);
      setCampaigns([]);
    } finally {
      setLoading(false);
    }
  }, [studentId, squadId]);

  useEffect(() => {
    if (!isOpen) return;
    load();
  }, [isOpen, load]);

  if (!isOpen) return null;

  return (
    <div className="attendance-modal-overlay" style={{ zIndex: 10000 }} onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="attendance-modal" style={{ width: '95%', maxWidth: 960, display: 'flex', flexDirection: 'column' }}>
        <div className="attendance-modal-header">
          <h2>Reflection Questions</h2>
          <button className="close-modal-btn" onClick={onClose}>×</button>
        </div>
        <div className="attendance-modal-content" style={{ overflowY: 'auto' }}>
          {loading ? (
            <div style={{ padding: '2rem', textAlign: 'center' }}>Loading…</div>
          ) : (
            <LevelRun
              levelId={levelId}
              studentId={studentId}
              squadId={squadId}
              sessionId={sessionId}
              campaigns={campaigns}
              onComplete={() => onClose()}
              onCancel={() => onClose()}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default StudentReflectionModal;
